if $('.flash-monkey')
  setTimeout(->
    $('.flash-monkey').fadeOut()
  , 5000)
